<template>
  <ReactPage>
    <acs-log-report-page></acs-log-report-page>
  </ReactPage>
</template>

<script>
import ReactPage from '../components/ReactPage.vue';

export default {
  name: "ACSLogReport",
  components: {
    ReactPage
  }
}
</script>